import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

// TODO: ver questão da referência ao Servidor do GESCON, pois no ambiente está com problema para fazer o apontamento de Produção e Homologação
// const api = `${process.env.VUE_APP_API_GESCON}${process.env.VUE_APP_API_PATH}`
const api = `${process.env.VUE_APP_API_GESCON}${process.env.VUE_APP_API_PATH}`
const token = localStorage.getItem('token')

export default {
    obterPorId(idRequisicao) {
        return axiosJwt
            .get(`${api}/contratos/requisicoes/${idRequisicao}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterContratos() {
        return axiosJwt
            .get(`${api}/contratos/requisicoes/contratosvigentes`, {
                headers: {
                    Authorization: `Bearer ${token}` // Pass the token in the Authorization header
                }
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterContrato(idContrato) {
        return axiosJwt
            .get(`${api}/contratos/requisicoes/contratosvigentes/${idContrato}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterSolicitantes() {
        return axiosJwt
            .get(`${api}/contratos/requisicoes/solicitantes`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterProcesso(numProcesso, operacao) {
        return axiosJwt
            .get(
                `${api}/contratos/requisicoes/processos?processo=${numProcesso}&operacao=${operacao}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    inserirRequisicao(requisicao) {
        return axiosJwt
            .post(`${api}/contratos/requisicoes/inserir`, requisicao)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterItensDisponiveis(idRequisicao) {
        return axiosJwt
            .get(
                `${api}/contratos/requisicoes/${idRequisicao}/itenscontratodisponiveis`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    inserirItensRequisicao(itensRequisicao) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${itensRequisicao.idRequisicao}/inseriritens`,
                itensRequisicao
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterTiposMovimentos(contratoId) {
        return axiosJwt
            .get(
                `${api}/comprometimentos/tiposmovimentos?contratoId=${contratoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarMovimento(novoMovimento) {
        return axiosJwt
            .post(
                `${api}/comprometimentos/atualizarmovimento`, novoMovimento)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterItensRequisicaoDisponiveis(idRequisicao) {
        return axiosJwt
            .get(
                `${api}/contratos/requisicoes/${idRequisicao}/itensrequisicaodisponiveis`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {

                return errorHandler(error)
            })
    },
    obterComprometimento(idRequisicao, idComprometimento) {
        return axiosJwt
            .get(
                `${api}/contratos/requisicoes/${idRequisicao}/comprometimentos/${idComprometimento}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    inserirRateioRequisicao(rateioRequisicao) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${rateioRequisicao.idRequisicao}/inserirrateio`,
                rateioRequisicao
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterDotacoesProcesso(idRequisicao) {
        return axiosJwt
            .get(
                `${api}/contratos/requisicoes/${idRequisicao}/dotacoesprocesso`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterDotacoesContrato(idRequisicao) {
        return axiosJwt
            .get(
                `${api}/contratos/requisicoes/${idRequisicao}/dotacoescontrato`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    comprometer(comprometimento) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${comprometimento.idRequisicao}/comprometer`,
                comprometimento
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    excluirRateioRequisicao(rateioRequisicao) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${rateioRequisicao.idRequisicao}/excluirrateio`,
                rateioRequisicao
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    atualizarRateioRequisicao(rateioRequisicao) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${rateioRequisicao.idRequisicao}/atualizarrateio`,
                rateioRequisicao
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    copiar(comprometimento) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${comprometimento.idRequisicao}/copiar`,
                comprometimento
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    enviarRequisicaoSolicitacao(idRequisicao) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${idRequisicao}/enviarSolicitacao`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    cancelarRequisicaoSolicitacao(idRequisicao) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${idRequisicao}/cancelarSolicitacao`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    atualizarRequisicao(requisicao) {
        return axiosJwt
            .post(`${api}/contratos/requisicoes/atualizar`, requisicao)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    verificarSaldoNatureza(comprometimentos) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/verificarsaldonatureza`,
                comprometimentos
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    comprometerSelecionados(comprometimentos) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${comprometimentos.idRequisicao}/comprometerselecionados`,
                comprometimentos
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    adicionarAvaliacaoGestorResponsavelRequisicao(idRequisicao, avaliacaoData) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${idRequisicao}/adicionarAvaliacaoGestorResponsavelRequisicao`,
                avaliacaoData
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    atualizarDescontoItemRequisicao(itemRequisicao) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${itemRequisicao.idRequisicao}/atualizardescontoitem`,
                itemRequisicao
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    atualizarItemRequisicao(itemRequisicao) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${itemRequisicao.idRequisicao}/atualizaritem`,
                itemRequisicao
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirItemRequisicao(itensRequisicao) {
        return axiosJwt
            .post(
                `${api}/contratos/requisicoes/${itensRequisicao.idRequisicao}/excluiritem`,
                itensRequisicao
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },


}
